'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["list", "children"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssColorValue, semanticColors } from "../../styles/index.mjs";
import styled from "../../styled-components.mjs";
var NavBarPage = styled.div.withConfig({
  displayName: "NavBar__NavBarPage",
  componentId: "sc-1guraqe-0"
})(["color:", ";overflow-wrap:break-word;"], cssColorValue(semanticColors.textBase));
/**
* **NavBar** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBar) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=20339:15819)
*
* A tab component used to toggle between between pages
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/navigation?format=figma-figma#nav-bar)
*
* @example
* () => (
*  <NavBar
*    list={
*      <nav aria-label="Main">
*        <NavBarList>
*          {navBarListItems.map((item, i) => (
*            <NavBarListItem
*              key={i}
*              id={`${item.toLowerCase()}Link`}
*              label={item}
*              active={i === 0}
*              disabled={i === 3}
*              href={`#${item}`}
*            />
*          ))}
*        </NavBarList>
*      </nav>
*    }
*  >
*    <div id="overview-page">
*      <Type as="h1" variant="altoBrio">
*        Overview page
*      </Type>
*      <Type>Laborum quis irure sint sunt ipsum culpa culpa consequat labore ut.</Type>
*    </div>
*  </NavBar>
*);
*
*/

/**
 * @deprecated
 * This component will be archived soon.
 * Please use the Tabs component instead.
 **/
export var NavBar = function NavBar(_ref) {
  var list = _ref.list,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("section", Object.assign({}, props, {
    "data-encore-id": ENCORE_DATA_IDS.NavBar
  }), list, /*#__PURE__*/React.createElement(NavBarPage, null, children));
};